import { render, staticRenderFns } from "./advancesRecharge.vue?vue&type=template&id=506adb4b&scoped=true&"
import script from "./advancesRecharge.vue?vue&type=script&lang=js&"
export * from "./advancesRecharge.vue?vue&type=script&lang=js&"
import style0 from "./advancesRecharge.vue?vue&type=style&index=0&id=506adb4b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506adb4b",
  null
  
)

export default component.exports